<div class="page-actions">
  @if (availableFilters$ | async; as availableFilters) {
    <dv-filter-area
      class="page-actions__filter-area"
      [availableFilters]="availableFilters | vtFilterPermissions"
      [isFilterPanelOpen]="isFleetFilterAreaOpen"
      [openPanelTooltip]="'Fleet.FilterPanel.Open' | translate"
      [closePanelTooltip]="'Fleet.FilterPanel.Close' | translate"
      [addFilterFn]="addFilterFn"
      (activeFilterChanged)="onActiveFilterChanged($event)"
      (filterAreasVisibilityToggled)="
        onFilterAreaToggled($event)
      "></dv-filter-area>
  }
</div>
<dv-vertical-splitter
  [resizableSide]="resizableSide.Left"
  id="fleet-vertical-splitter">
  <div left-side>
    <app-fleet-grid
      #fleetGrid
      (filtersCleared)="onFleetGridFiltersCleared()"></app-fleet-grid>
  </div>
  <div right-side>
    <app-fleet-map></app-fleet-map>
  </div>
</dv-vertical-splitter>
